export default __webpack_public_path__ + "static/media/noTournamentIcon.a9fc10b6.svg";